"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const infoBannerInputs = [
  {
    name: "showInfoBanner",
    friendlyName: "Should show info banner",
    type: "boolean",
    defaultValue: true,
    required: true,
  },
  {
    name: "bannerType",
    type: "string",
    required: true,
    enum: [
      { label: "Green", value: "green" },
      { label: "Amber", value: "amber" },
      { label: "Default", value: "auto" },
    ],
    defaultValue: "auto",
  },
  {
    name: "content",
    type: "string",
    required: true,
    defaultValue:
      "Aenean gravida orci arcu, eu tempus turpis consectetur et. Duis finibus urna id mi molestie pellentesque. Cras in nulla vitae nibh suscipit pulvinar.",
  },
  {
    name: "ctaLabel",
    friendlyName: "Button label",
    type: "string",
    required: true,
    defaultValue: "Button label",
  },
  {
    name: "ctaLink",
    friendlyName: "Button url",
    type: "url",
    required: true,
    defaultValue: "#",
  },
  {
    name: "hideCta",
    friendlyName: "Should hide CTA ?",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "hideCloseIcon",
    friendlyName: "Should hide CloseIcon ?",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
] as const satisfies Inputs;

export const InfoBanner: RegisteredComponent = {
  name: "InfoBanner",
  component: dynamic(async () =>
    withValidation(
      infoBannerInputs,
      (await import("./InfoBanner")).InfoBanner,
      "InfoBanner"
    )
  ),
  inputs: infoBannerInputs,
};
